import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Badge, Spin, Input, Form, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { formatNumber } from 'utils/formatting';
import { DatePickerInput } from 'components';

import { connect } from 'react-redux';
import { getOrders, getAllOrders, approveOrder, cancelOrder } from 'data/order';
// import { getOrders, getPageList, postNewPageContent } from 'data/content';

import { TableHelper, exportAsExcel } from 'helpers/Table';
import moment from 'moment';
import Utils from 'utils/utils';

import classes from '../styles/order/Order.module.scss';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const pageLimit = 20;

const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

class Order extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onApproveOrder = this.onApproveOrder.bind(this);
    this.onCancelOrders = this.onCancelOrders.bind(this);
    this.onApproveOrders = this.onApproveOrders.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(1, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    this.state = {
      collapseMobile: [],
      selectedRowKeys: [],
      showModal: false,
      ...props.location.query,
      displaySearchValue: props.location.query.q,
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      start,
      end,
    };
  }

  componentDidMount = async () => {
    this.setState({
      loading: true,
    });
    const orders = await getOrders(this.props.location.query);
    this.setState({
      orders: orders.results,
      page: orders.currentPage,
      count: orders.count,
      loading: false,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }
  componentWillReceiveProps(props) {
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(1, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    this.setState({
      ...props.location.query,
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      displaySearchValue: props.location.query.q,
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      start,
      end,
    });
  }

  onApproveOrder(id) {
    approveOrder(id).then(() => {
      this.getOrders(this.getCurrentQuery()).then(_.noop);
    });
    this.setState({
      selectedRowKeys: [],
    });
  }
  onApproveOrders() {
    const ids = this.state.selectedRowKeys.map((key) => {
      return this.state.orders[key]._id;
    });
    ids.forEach((id) => {
      const promises = [];
      promises.push(approveOrder(id));
      Promise.all(promises).then(() => {
        this.getOrders(this.getCurrentQuery()).then(_.noop);
      });
      this.setState({
        selectedRowKeys: [],
      });
    });
  }
  onCancelOrders() {
    const ids = this.state.selectedRowKeys.map((key) => {
      return this.state.orders[key]._id;
    });
    ids.forEach((id) => {
      const promises = [];
      promises.push(cancelOrder(id));
      Promise.all(promises).then(() => {
        this.getOrders(this.getCurrentQuery()).then(_.noop);
      });
      this.setState({
        selectedRowKeys: [],
      });
    });
  }

  onClickRow(record, index) {
    // this.setState({
    //   showModal: true,
    //   selectedRow: record,
    //   isAddNew: false,
    // });
  }

  onSearchInputPress = (event) => {
    if (event.charCode === 13) {
      this.onSearch();
    }
  };

  onChangePage(page) {
    this.getOrders(_.merge(this.getCurrentQuery(), { page }));
    this.setState({
      page,
      selectedRowKeys: [],
    });
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearch() {
    this.getOrders(_.merge(this.getCurrentQuery(), { page: 1 })).then(_.noop);
    this.setState({ page: 1, selectedRowKeys: [] });
  }
  getCurrentQuery() {
    const queryObj = {
      page: this.state.page,
      status: this.state.selectedStatus,
      q: this.state.displaySearchValue,
      sortBy: this.state.sortBy,
      start: this.state.start.format('DD-MM-YYYY'),
      end: this.state.end.format('DD-MM-YYYY'),
    };
    console.log(Utils.createQueryString(queryObj));
    return queryObj;
  }
  getOrders = async (query) => {
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);

    this.setState({
      loading: true,
    });
    const orders = await getOrders(query);
    this.setState({
      orders: orders.results,
      page: orders.currentPage,
      count: orders.count,
      loading: false,
    });

    // return this.getOrders(query);
  };

  exportToExcel() {
    getAllOrders(this.getCurrentQuery()).then((resultObj) => {
      const results = resultObj.results;
      const content = _.map(results, (singleContent, key) => {
        singleContent.key = key;
        return singleContent;
      });
      exportAsExcel({
        filename: `ORDERS-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
        sheetName: 'Sheet1',
        columns: this.columns,
        data: content,
      });
    });
  }

  changeFocusPage(event) {
    const status = event.key;
    this.getOrders(_.merge(this.getCurrentQuery(), { status, page: 1 }));
    // this.getOrders(_.merge(this.getCurrentQuery(), { status })).then((response) => {
    //   console.log(response);
    // });
    this.setState({
      selectedStatus: status,
      selectedRowKeys: [],
      page: 1,
    });
  }

  columns = [
    {
      ...TableHelper.defaultColumn('Code', 'code'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/order/${record._id}`}>{Utils.FormatNumberLength(value, 6)} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      ...TableHelper.datetimeColumn('Order\nDate &\nTime', 'createdAt'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Class', 'class.name'),
      render: (value, record) => (
        <div>
          <Link to={`/class/${record.class._id}`}>{value}</Link>
        </div>
      ),
      // width: '500px',
    },
    {
      ...TableHelper.dateColumn('Sche.\nDate', 'schedule.start'),
    },

    {
      ...TableHelper.defaultColumn('Sche. No.', 'schedule.code'),
      render: (value, record) => <Link to={`/class/${record.class._id}/schedule/${record.schedule._id}`}>{value}</Link>,
      // width: '500px',
    },
    {
      ...TableHelper.defaultColumn('Student', 'studentName'),
      render: (value, record) => <Link to={`/student/${record.student._id}`}>{record.student && record.student.name ? `${record.student.name.first} ${record.student.name.last}` : 'not exist'}</Link>,
      renderExcel: (value, record) => <span>{record.student && record.student.name ? `${record.student.name.first} ${record.student.name.last}` : 'not exist'}</span>,
    },
    {
      ...TableHelper.defaultColumn('Payment\nMethod', 'paymentMethod'),
      // title: 'Payment method',
      // dataIndex: 'paymentMethod',
      render: (value) => <span>{value === 'cc' ? 'Credit card' : 'Bank Transfer'}</span>,
      sorter: true,
    },
    {
      ...TableHelper.datetimeColumn('Transfer\nDate', 'paymentDetail.dateTime'),
      sorter: true,
    },
    {
      ...TableHelper.priceColumn('Amount\nDue', 'paidPrice'),
    },
    {
      ...TableHelper.priceColumn('Amount\nPaid', 'paymentDetail.money'),
      render: (value, record) => {
        if (value) {
          return formatPrice(value);
        }
        if (record.status === 'rejected' || record.status === 'pending') {
          return '';
        }

        return formatPrice(record.paidPrice);
      },
      renderExcel: (value, record) => {
        if (value) {
          return formatPrice(value);
        }
        if (record.status === 'rejected' || record.status === 'pending') {
          return '';
        }
        return formatPrice(record.paidPrice);
      },
    },
    {
      ...TableHelper.priceColumn('Promo\nDisc', 'promocodeDiscountAmount'),
    },
    {
      ...TableHelper.defaultColumn('Promo\nCode', 'promocode'),
    },

    {
      ...TableHelper.defaultColumn('Status', 'status'),
      render: (value) => (
        <div>
          {value === 'pending' && <Badge status="default" text="Pending" />}
          {value === 'confirm' && <Badge status="warning" text="Confirmed" />}
          {value === 'paid' && <Badge status="processing" text="Paid" />}
          {value === 'success' && <Badge status="success" text="Success" />}
          {value === 'rejected' && <Badge status="error" text="Cancelled" />}
          {value === 'refunded' && <Badge status="warning" text="Refunded" />}
        </div>
      ),
      sorter: true,
    },
    {
      title: '',
      dataIndex: '',
      render: (value, record) => (
        <div>
          {(record.status === 'pending' || (record.status === 'confirm' && !_.get(record, 'schedule.isSummary'))) && (
            <Button type="success" onClick={() => this.onApproveOrder(record._id)}>
              App
            </Button>
          )}
        </div>
      ),
    },
  ];
  orderStatuses = [
    { label: 'All', value: 'all' },
    { label: 'Pending', value: 'pending' },
    { label: 'Confirmed', value: 'confirm' },
    { label: 'Paid', value: 'paid' },
    { label: 'Success', value: 'success' },
    { label: 'Cancelled', value: 'rejected' },
    { label: 'Refunded', value: 'refunded' },
  ];
  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
        {this.orderStatuses &&
          this.orderStatuses.map((singleClass) => (
            <Menu.Item key={singleClass.value} className={classes.dashRight}>
              <div>{singleClass.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.orders, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    // const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
      },
      hideDefaultSelections: true,
    };
    const hasRowSelection = this.state.selectedStatus === 'confirm';
    const customColumn = this.columns.reduce((result, col) => {
      if (this.state.selectedStatus !== 'all' && col.key === 'status') {
        return result;
      }
      result.push(col);
      return result;
    }, []);

    console.log(this.state.orders, content);

    return (
      <div>
        <Table
          rowSelection={hasRowSelection ? rowSelection : undefined}
          columns={customColumn}
          dataSource={content}
          bordered
          pagination={false}
          onRowClick={this.onClickRow}
          onChange={this.onTableChange}
          scroll={{ x: 1400 }}
        />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!loading}>
            {this.renderPageTopMenu()}
            <div className={classes.searchContainer}>
              <Row>
                <Col xs={7} className={classes.searchInputContainer}>
                  <Input
                    prefix={<Icon type="search" />}
                    value={this.state.displaySearchValue}
                    placeholder="Search"
                    onKeyPress={(e) => this.onSearchInputPress(e)}
                    onChange={(e) => this.onInputSearch(e)}
                  />
                </Col>
                <Col xs={7}>
                  <DatePickerInput start={this.state.start} end={this.state.end} onChange={(momentDates) => this.setState({ start: momentDates[0], end: momentDates[1] })} />
                </Col>

                <Button className="search-btn" onClick={this.onSearch}>
                  <Icon type="search" />
                </Button>
              </Row>
            </div>

            <div className={classes.topCommand}>
              <div className={'pull-right'}>
                <a onClick={() => this.exportToExcel()}>
                  <Icon type="file-excel" /> Export to excel
                </a>
              </div>
              <div>
                {this.state.selectedRowKeys.length > 0 && this.state.selectedStatus === 'confirm' && (
                  <div>
                    <Button type="success">
                      <a onClick={() => this.onApproveOrders()}>Approve Selected ({this.state.selectedRowKeys.length})</a>
                    </Button>{' '}
                  </div>
                )}{' '}
              </div>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}
export default connect((state) => ({}))(Form.create()(Order));
